<div  class="tablet:tw-rounded-lg tw-rounded-0 tw-shadow-md bg-survey tablet:tw-max-h-full tw-max-h-[100vh] tw-overflow-auto">
  <div (click)="onCloseForm();"
    class="tw-flex tw-w-full tw-justify-end tablet:tw-hidden tw-pt-[12px] tw-pr-[12px] tw-block">
    <img src="./assets/images/story/close_square_2.svg" alt="close"
      class="!tw-w-[20px] !tw-h-[20px] tw-cursor-pointer ">
  </div>
  
  <div
    class="tw-px-[12px] tw-border-none tw-flex-col-reverse tw-items-start tw-border-b-[2px] tablet:tw-border-[#E3E3E3] tw-rounded-t-[20px] tw-flex tablet:tw-flex-row tablet:tw-items-center tablet:tw-justify-between tw-bg-[#F0F7FB] tablet:tw-pt-[25px] tablet:tw-pr-[25px] tablet:tw-pb-[10px] tablet:tw-pl-[32px]">
    <div class="tw-flex tw-flex-col tw-gap-1">
      <span class="tw-text-[#106B8E] tw-text-[22px] tw-font-bold tw-leading-[24px] tw-normal-case tw-capitalize">
        {{isProposeForm?'Custom Giving':formTitle}}</span>
      <span class="tw-text-[#041519] tw-text-sm tw-font-normal tw-leading-[22px]">
        {{isProposeForm?proposeFormDescription:formDescription}} </span>
    </div>
    <div class="tw-flex tw-flex-row tw-items-center tw-gap-1">
      <svg xmlns="http://www.w3.org/2000/svg" width="148" height="32" viewBox="0 0 148 32" fill="none">
        <path
          d="M129.881 14.109C129.881 13.0047 130.774 12.1059 131.872 12.1059H137.827C137.807 12.0838 137.788 12.0601 137.768 12.0397L131.891 6.12727C131.318 5.55133 130.387 5.55133 129.815 6.12727L123.937 12.0397C123.365 12.6156 123.365 13.5517 123.937 14.1277L129.815 20.0401C129.837 20.0622 129.859 20.0809 129.881 20.0996V14.109Z"
          fill="#106B8E" />
        <path
          d="M140.283 12.5938H131.837C131.012 12.5938 130.344 13.2662 130.344 14.0956V22.5922C130.344 23.4216 131.012 24.094 131.837 24.094H140.283C141.108 24.094 141.776 23.4216 141.776 22.5922V14.0956C141.776 13.2662 141.108 12.5938 140.283 12.5938Z"
          fill="#106B8E" />
        <path
          d="M141.685 26.3087H130.439C129.988 26.3087 129.621 25.9417 129.621 25.4864C129.621 25.031 129.986 24.6641 130.439 24.6641H141.685C142.136 24.6641 142.503 25.031 142.503 25.4864C142.503 25.9417 142.138 26.3087 141.685 26.3087Z"
          fill="#106B8E" />
        <path
          d="M14.54 13.447C14.4521 13.6169 14.241 13.6781 14.0755 13.5863C13.7951 13.4283 13.5334 13.2958 13.2901 13.1871C12.9625 13.0393 12.6061 12.9084 12.2193 12.7895C11.8326 12.6723 11.4526 12.6128 11.0793 12.6128C10.7871 12.6128 10.5473 12.6604 10.3598 12.7521C10.1723 12.8456 10.0794 13.0036 10.0794 13.2245C10.0794 13.4334 10.1723 13.6033 10.3598 13.7307C10.5473 13.8599 10.8124 13.9754 11.1587 14.0807C11.5032 14.1861 11.9153 14.3135 12.395 14.4647C13.1669 14.6975 13.834 14.9659 14.3947 15.2683C14.9555 15.5724 15.3895 15.9598 15.6935 16.4321C15.9975 16.9044 16.1495 17.5313 16.1495 18.3128C16.1495 19.0944 16.0144 19.6856 15.7459 20.1936C15.4773 20.7016 15.1142 21.1059 14.6582 21.4084C14.2022 21.7125 13.6938 21.9299 13.1314 22.0642C12.5707 22.1984 11.9964 22.2646 11.412 22.2646C10.8276 22.2646 10.1926 22.2035 9.54404 22.0795C8.89548 21.9554 8.2655 21.7855 7.65748 21.5681C7.1643 21.3914 6.70491 21.1892 6.27929 20.9615C6.11715 20.8749 6.05128 20.6761 6.13235 20.5096L7.30449 18.109C7.39062 17.934 7.60681 17.8677 7.7757 17.9646C8.12363 18.165 8.44622 18.3332 8.74517 18.4692C9.13194 18.6458 9.56093 18.8039 10.0355 18.9449C10.5084 19.0859 10.9864 19.1572 11.4661 19.1572C11.841 19.1572 12.1011 19.1097 12.2464 19.0145C12.3933 18.9194 12.4659 18.7937 12.4659 18.6357C12.4659 18.391 12.3376 18.2007 12.0792 18.0665C11.8224 17.9323 11.4847 17.8032 11.0709 17.6808C10.6554 17.5585 10.196 17.4158 9.69436 17.251C8.9698 17.0063 8.37191 16.7277 7.90407 16.4185C7.43622 16.1093 7.09168 15.7406 6.86874 15.3142C6.64579 14.8877 6.53601 14.3713 6.53601 13.763C6.53601 12.8405 6.7522 12.0692 7.18457 11.449C7.61694 10.8289 8.18781 10.36 8.89548 10.0372C9.60316 9.71609 10.3666 9.55469 11.1857 9.55469C11.7937 9.55469 12.3815 9.62774 12.949 9.77555C13.5165 9.92336 14.0485 10.1018 14.545 10.3141C14.9082 10.4687 15.2409 10.6182 15.5381 10.761C15.7104 10.8442 15.7797 11.0532 15.6918 11.2248L14.5417 13.4436V13.447H14.54Z"
          fill="#106B8E" />
        <path
          d="M21.5534 22.3535C20.746 22.3535 20.0265 22.2295 19.3949 21.9798C18.7632 21.73 18.2346 21.3919 17.8073 20.9621C17.3799 20.5339 17.0557 20.0412 16.8327 19.484C16.6098 18.9284 16.5 18.3423 16.5 17.7289C16.5 16.8506 16.6925 16.0453 17.0793 15.3113C17.4661 14.5774 18.0319 13.9878 18.7818 13.5427C19.53 13.0976 20.4538 12.875 21.5534 12.875C22.6529 12.875 23.5767 13.0959 24.3249 13.5359C25.0731 13.9759 25.6406 14.5553 26.0274 15.2739C26.4142 15.9926 26.6067 16.7741 26.6067 17.6202C26.6067 17.7935 26.5983 17.9702 26.5797 18.1503C26.5628 18.3304 26.5408 18.4901 26.5189 18.6277H20.0451C20.0688 18.9403 20.16 19.1951 20.317 19.3905C20.4758 19.5859 20.6734 19.7286 20.9132 19.817C21.1531 19.907 21.4014 19.9512 21.6598 19.9512C22.0229 19.9512 22.3641 19.8696 22.6866 19.7031C22.9265 19.5808 23.1055 19.4211 23.2254 19.2274C23.3014 19.1034 23.4568 19.0524 23.597 19.0932L25.7369 19.7082C25.9582 19.7711 26.051 20.031 25.9244 20.2247C25.7082 20.5577 25.4413 20.8618 25.1238 21.1337C24.6847 21.5108 24.1679 21.8065 23.5717 22.0256C22.9755 22.2431 22.3016 22.3518 21.5534 22.3518V22.3535ZM19.9742 16.6178H23.0278C22.9923 16.3307 22.9079 16.0877 22.7728 15.889C22.6377 15.6902 22.462 15.5356 22.2458 15.4251C22.0296 15.3147 21.7814 15.2586 21.4993 15.2586C21.2173 15.2586 20.9707 15.3147 20.7528 15.4251C20.5366 15.5356 20.361 15.6902 20.2258 15.889C20.0907 16.0877 20.0063 16.3307 19.9708 16.6178H19.9742Z"
          fill="#106B8E" />
        <path
          d="M32.069 22.3535C31.2617 22.3535 30.5422 22.2295 29.9105 21.9798C29.2788 21.73 28.7502 21.3919 28.3229 20.9621C27.8956 20.5339 27.5713 20.0412 27.3483 19.484C27.1254 18.9284 27.0156 18.3423 27.0156 17.7289C27.0156 16.8506 27.2082 16.0453 27.5949 15.3113C27.9817 14.5774 28.5475 13.9878 29.2974 13.5427C30.0456 13.0976 30.9695 12.875 32.069 12.875C33.1685 12.875 34.0923 13.0959 34.8406 13.5359C35.5888 13.9759 36.1563 14.5553 36.543 15.2739C36.9298 15.9926 37.1223 16.7741 37.1223 17.6202C37.1223 17.7935 37.1139 17.9702 37.0953 18.1503C37.0784 18.3304 37.0565 18.4901 37.0345 18.6277H30.5607C30.5844 18.9403 30.6756 19.1951 30.8327 19.3905C30.9914 19.5859 31.189 19.7286 31.4289 19.817C31.6687 19.907 31.917 19.9512 32.1754 19.9512C32.5385 19.9512 32.8797 19.8696 33.2023 19.7031C33.4421 19.5808 33.6211 19.4211 33.741 19.2274C33.8171 19.1034 33.9724 19.0524 34.1126 19.0932L36.2525 19.7082C36.4738 19.7711 36.5667 20.031 36.44 20.2247C36.2238 20.5577 35.957 20.8618 35.6394 21.1337C35.2003 21.5108 34.6835 21.8065 34.0873 22.0256C33.4911 22.2431 32.8172 22.3518 32.069 22.3518V22.3535ZM30.4898 16.6178H33.5434C33.508 16.3307 33.4235 16.0877 33.2884 15.889C33.1533 15.6902 32.9776 15.5356 32.7615 15.4251C32.5453 15.3147 32.297 15.2586 32.0149 15.2586C31.7329 15.2586 31.4863 15.3147 31.2684 15.4251C31.0522 15.5356 30.8766 15.6902 30.7415 15.889C30.6063 16.0877 30.5219 16.3307 30.4864 16.6178H30.4898Z"
          fill="#106B8E" />
        <path
          d="M47.3897 21.8385V15.5778L45.3917 20.0189C45.3377 20.1412 45.2161 20.2194 45.0843 20.2194H43.696C43.5626 20.2194 43.4427 20.1412 43.3886 20.0189L41.3906 15.5778V21.8385C41.3906 22.0254 41.2386 22.1783 41.0528 22.1783H38.3065C38.1208 22.1783 37.9688 22.0254 37.9688 21.8385V9.98823C37.9688 9.80134 38.1208 9.64844 38.3065 9.64844H41.4885C41.6203 9.64844 41.7402 9.72659 41.7959 9.84722L44.3902 15.5438L47.0013 9.84722C47.057 9.72659 47.1769 9.65014 47.3087 9.65014H50.4738C50.6596 9.65014 50.8116 9.80304 50.8116 9.98993V21.8419C50.8116 22.0288 50.6596 22.1817 50.4738 22.1817H47.7275C47.5418 22.1817 47.3897 22.0288 47.3897 21.8419V21.8385Z"
          fill="#106B8E" />
        <path
          d="M51.9775 23.5747C51.9775 23.3504 52.192 23.1856 52.4065 23.2485C52.5163 23.2808 52.621 23.308 52.7223 23.3317C52.9504 23.3844 53.1581 23.4116 53.3456 23.4116C53.5905 23.4116 53.7965 23.3674 53.9604 23.2791C54.1242 23.1907 54.2525 23.0565 54.3471 22.8747C54.44 22.6929 54.4991 22.4721 54.5228 22.2121L51.3374 13.4726C51.2563 13.2501 51.4202 13.0156 51.6549 13.0156H54.3421C54.4907 13.0156 54.6224 13.1125 54.6646 13.2569L56.3468 18.8023L57.7048 13.2739C57.7419 13.1227 57.877 13.0156 58.0324 13.0156H60.4172C60.6436 13.0156 60.8074 13.2365 60.7398 13.454L57.7504 23.313C57.5747 23.9077 57.2876 24.4293 56.8907 24.8778C56.4938 25.3263 56.0192 25.6763 55.4703 25.9278C54.9197 26.1792 54.3302 26.3049 53.6986 26.3049C53.4064 26.3049 53.1159 26.2777 52.8304 26.2251C52.6227 26.186 52.4166 26.1316 52.2123 26.0586C52.0738 26.0093 51.9792 25.8819 51.9792 25.7358V23.5747H51.9775Z"
          fill="#106B8E" />
        <path
          d="M61.7148 21.8385V9.98823C61.7148 9.80134 61.8668 9.64844 62.0526 9.64844H64.7989C64.9847 9.64844 65.1367 9.80134 65.1367 9.98823V19.1796H70.4484C70.6342 19.1796 70.7862 19.3325 70.7862 19.5194V21.8402C70.7862 22.0271 70.6342 22.18 70.4484 22.18H62.0526C61.8668 22.18 61.7148 22.0271 61.7148 21.8402V21.8385Z"
          fill="#106B8E" />
        <path
          d="M76.2955 22.3535C75.4882 22.3535 74.7687 22.2295 74.1371 21.9798C73.5054 21.73 72.9767 21.3919 72.5494 20.9621C72.1221 20.5339 71.7979 20.0412 71.5749 19.484C71.352 18.9284 71.2422 18.3423 71.2422 17.7289C71.2422 16.8506 71.4347 16.0453 71.8215 15.3113C72.2083 14.5774 72.7741 13.9878 73.524 13.5427C74.2722 13.0976 75.196 12.875 76.2955 12.875C77.3951 12.875 78.3189 13.0959 79.0671 13.5359C79.8153 13.9759 80.3828 14.5553 80.7696 15.2739C81.1564 15.9926 81.3489 16.7741 81.3489 17.6202C81.3489 17.7935 81.3405 17.9702 81.3219 18.1503C81.305 18.3304 81.283 18.4901 81.2611 18.6277H74.7873C74.811 18.9403 74.9022 19.1951 75.0592 19.3905C75.218 19.5859 75.4156 19.7286 75.6554 19.817C75.8953 19.907 76.1435 19.9512 76.4019 19.9512C76.7651 19.9512 77.1062 19.8696 77.4288 19.7031C77.6687 19.5808 77.8477 19.4211 77.9676 19.2274C78.0436 19.1034 78.199 19.0524 78.3392 19.0932L80.4791 19.7082C80.7003 19.7711 80.7932 20.031 80.6666 20.2247C80.4504 20.5577 80.1835 20.8618 79.866 21.1337C79.4269 21.5108 78.91 21.8065 78.3138 22.0256C77.7176 22.2431 77.0437 22.3518 76.2955 22.3518V22.3535ZM74.7164 16.6178H77.77C77.7345 16.3307 77.6501 16.0877 77.515 15.889C77.3799 15.6902 77.2042 15.5356 76.988 15.4251C76.7718 15.3147 76.5236 15.2586 76.2415 15.2586C75.9594 15.2586 75.7129 15.3147 75.495 15.4251C75.2788 15.5356 75.1031 15.6902 74.968 15.889C74.8329 16.0877 74.7485 16.3307 74.713 16.6178H74.7164Z"
          fill="#106B8E" />
        <path
          d="M107.762 22.3518C106.943 22.3518 106.22 22.2244 105.595 21.9696C104.968 21.7147 104.439 21.3647 104.007 20.9196C103.575 20.4745 103.247 19.9682 103.024 19.4007C102.801 18.8333 102.691 18.2369 102.691 17.6134C102.691 16.7809 102.887 16.0028 103.279 15.279C103.671 14.5553 104.244 13.9742 104.999 13.5342C105.753 13.0942 106.674 12.875 107.762 12.875C108.849 12.875 109.809 13.1112 110.569 13.5818C111.19 13.9674 111.683 14.4431 112.048 15.0089C112.172 15.2009 112.082 15.4574 111.864 15.5237L109.246 16.3205C109.118 16.3596 108.981 16.3171 108.893 16.2152C108.77 16.0742 108.63 15.9603 108.473 15.8754C108.257 15.7581 108.013 15.6987 107.745 15.6987C107.441 15.6987 107.165 15.7751 106.921 15.928C106.676 16.0809 106.48 16.2984 106.333 16.5804C106.186 16.8625 106.113 17.2074 106.113 17.6134C106.113 18.0195 106.186 18.3508 106.333 18.6396C106.48 18.9284 106.676 19.1476 106.921 19.3005C107.165 19.4534 107.441 19.5298 107.745 19.5298C107.932 19.5298 108.101 19.5027 108.253 19.45C108.405 19.3973 108.549 19.3175 108.684 19.2121C108.76 19.151 108.831 19.0864 108.893 19.0134C108.983 18.9131 109.118 18.8689 109.246 18.908L111.866 19.7048C112.077 19.7694 112.177 20.0208 112.057 20.2077C111.84 20.5492 111.575 20.8567 111.261 21.1337C110.834 21.5108 110.331 21.8065 109.753 22.0256C109.174 22.2431 108.51 22.3518 107.762 22.3518Z"
          fill="#106B8E" />
        <path
          d="M113.044 23.5747C113.044 23.3504 113.258 23.1856 113.473 23.2485C113.583 23.2808 113.687 23.308 113.789 23.3317C114.017 23.3844 114.224 23.4116 114.412 23.4116C114.657 23.4116 114.863 23.3674 115.027 23.2791C115.191 23.1907 115.319 23.0565 115.414 22.8747C115.506 22.6929 115.566 22.4721 115.589 22.2121L112.404 13.4726C112.323 13.2501 112.487 13.0156 112.721 13.0156H115.408C115.557 13.0156 115.689 13.1125 115.731 13.2569L117.413 18.8023L118.771 13.2739C118.808 13.1227 118.943 13.0156 119.099 13.0156H121.484C121.71 13.0156 121.874 13.2365 121.806 13.454L118.817 23.313C118.641 23.9077 118.354 24.4293 117.957 24.8778C117.56 25.3263 117.086 25.6763 116.537 25.9278C115.986 26.1792 115.397 26.3049 114.765 26.3049C114.473 26.3049 114.182 26.2777 113.897 26.2251C113.689 26.186 113.483 26.1316 113.279 26.0586C113.14 26.0093 113.046 25.8819 113.046 25.7358V23.5747H113.044Z"
          fill="#106B8E" />
        <path
          d="M89.1262 13.3558V14.3922C88.834 13.8859 88.4337 13.507 87.9237 13.2539C87.4153 13.0007 86.8326 12.875 86.1773 12.875C85.522 12.875 84.9663 12.9939 84.4411 13.2284C83.9141 13.4645 83.4615 13.7992 83.0814 14.2359C82.7014 14.6725 82.4059 15.1822 82.1947 15.7649C81.9836 16.3477 81.8789 16.9882 81.8789 17.6831C81.8789 18.3779 81.9752 18.9556 82.1677 19.5214C82.3603 20.0871 82.6322 20.5832 82.9835 21.0062C83.3348 21.431 83.7587 21.7606 84.2553 21.9967C84.7518 22.2329 85.299 22.3501 85.8952 22.3501C86.4914 22.3501 87.0268 22.2295 87.5352 21.9882C88.0436 21.747 88.427 21.3851 88.6837 20.9026V21.5023C88.6837 22.0562 88.579 22.4792 88.3679 22.7749C88.1568 23.0705 87.8798 23.2846 87.5352 23.4188C87.1907 23.553 86.8123 23.621 86.4036 23.621C85.8648 23.621 85.3598 23.5122 84.8852 23.2947C84.5154 23.1249 84.186 22.9244 83.8989 22.6933C83.7621 22.5846 83.5662 22.5965 83.4446 22.7222L82.1458 24.0814C82.014 24.2207 82.0225 24.4416 82.1626 24.5707C82.6626 25.0294 83.225 25.3879 83.8499 25.6495C84.5812 25.9553 85.4325 26.1082 86.4019 26.1082C87.5251 26.1082 88.5081 25.9129 89.3492 25.5221C90.192 25.1313 90.8456 24.5809 91.3134 23.8707C91.7813 23.1588 92.016 22.3263 92.016 21.3698V13.3524C92.016 13.1655 91.864 13.0126 91.6782 13.0126H89.4589C89.2732 13.0126 89.1211 13.1655 89.1211 13.3524L89.1262 13.3558ZM88.6871 18.7466C88.6871 18.7466 88.6786 18.7585 88.6736 18.7636C88.3493 19.3277 87.7751 19.7031 87.1197 19.7031H87.091C86.8343 19.7031 86.5945 19.6556 86.3715 19.5621C86.1486 19.467 85.956 19.3345 85.7922 19.1629C85.6284 18.9913 85.5034 18.7874 85.4156 18.5512C85.3278 18.3151 85.2838 18.0551 85.2838 17.7714V17.7018C85.2838 17.4724 85.321 17.2515 85.3869 17.046C85.3936 17.0222 85.3987 16.9984 85.4071 16.9746C85.4882 16.7266 85.6064 16.5057 85.7584 16.3103C85.9104 16.1149 86.0895 15.9654 86.2938 15.8584C86.4982 15.7513 86.7178 15.6987 86.9525 15.6987C86.9796 15.6987 87.0066 15.7021 87.0336 15.7038C87.064 15.7038 87.0927 15.6987 87.1231 15.6987C88.1382 15.6987 88.959 16.5957 88.959 17.7018C88.959 18.0823 88.8594 18.4374 88.6905 18.7415V18.7483H88.6871V18.7466Z"
          fill="#106B8E" />
        <path
          d="M101.752 19.1357C101.657 19.0151 101.611 18.7993 101.611 18.4901V16.7333C101.611 15.4591 101.211 14.4975 100.409 13.8485C99.6083 13.1995 98.4767 12.875 97.014 12.875C96.2304 12.875 95.4957 12.9718 94.8116 13.1655C94.2205 13.3337 93.6547 13.5767 93.1126 13.8978C92.9639 13.9861 92.9099 14.1747 92.9825 14.331L93.6581 15.7887C93.7425 15.9722 93.9689 16.0402 94.1394 15.9348C94.5161 15.7055 94.8809 15.5237 95.2322 15.3895C95.6831 15.2196 96.1645 15.1329 96.6796 15.1329C97.2404 15.1329 97.6474 15.2349 97.8991 15.437C98.1507 15.6392 98.2757 15.9501 98.2757 16.3681V16.6501C98.0409 16.5329 97.7639 16.4445 97.443 16.3851C97.1205 16.3256 96.7793 16.2967 96.4162 16.2967C95.6443 16.2967 94.9569 16.4292 94.3539 16.696C93.751 16.961 93.2815 17.3297 92.942 17.7969C92.6025 18.2658 92.4336 18.8061 92.4336 19.4177C92.4336 19.9733 92.5738 20.4728 92.8542 20.9179C93.1345 21.363 93.5213 21.713 94.0128 21.9679C94.5043 22.2227 95.0532 22.3501 95.6612 22.3501C96.2692 22.3501 96.8418 22.2108 97.3806 21.9356C97.9176 21.6586 98.3922 21.256 98.801 20.7259L98.8719 21.0606C98.9648 21.4837 99.1675 21.8048 99.4765 22.0222C99.7856 22.2397 100.24 22.3484 100.836 22.3484C101.024 22.3484 101.236 22.3331 101.476 22.3043C101.632 22.2856 101.794 22.2601 101.963 22.2278C102.132 22.1955 102.24 22.0562 102.24 21.8931V19.4925C102.24 19.4126 102.182 19.343 102.105 19.3277C101.941 19.2937 101.823 19.2291 101.748 19.1323L101.752 19.1357ZM97.2505 20.1313C96.3841 20.3623 95.5413 20.0225 95.3707 19.3718C95.2001 18.7228 95.7642 18.0076 96.6307 17.7782C97.4971 17.5472 98.3399 17.8869 98.5105 18.5376C98.6811 19.1884 98.1169 19.9019 97.2505 20.1313Z"
          fill="#106B8E" />
      </svg>
      <img (click)="onCloseForm()" src="./assets/images/story/close_square_2.svg" alt="close"
        class="!tw-w-[20px] !tw-h-[20px] tw-cursor-pointer tw-hidden tablet:tw-block">
    </div>
  </div>
  @if(isOverView && !isProposeForm){
  <div
    class="tw-hidden tablet:tw-flex tw-m-[12px] tablet:tw-ml-[32px] tablet:tw-mt-[12px] tablet:tw-mb-[0px] tablet:tw-mr-[32px] tw-items-start tw-justify-between tw-bg-white tw-border tw-border-[#E3E3E3] tw-rounded-[12px] tw-p-4 tw-gap-4 tw-shadow-sm tw-h-[174px] tablet:tw-h-[182px]">
    <div class="tw-flex tw-gap-4 tw-items-start tw-flex-1">
      <div class="tablet:tw-w-[150px] tablet:tw-h-[150px]">
        <img class="tw-w-full tw-h-full tw-bg-white tw-object-cover tw-rounded-[13px]" [src]="isEmpty(itemData()) 
        ? './assets/images/landing/static_image.png' 
        : (itemData().featureImage 
            ? itemData().featureImage 
            : getDefaultImage(itemData()?.campaignTypeId))" [alt]="itemData()?.name">
      </div>
      <div class="tw-flex tw-flex-col tw-flex-1">
        <span
          class="tw-text-[12px] tw-font-medium tw-leading-[18px] tw-text-[#106B8E] tablet:tw-pb-[11px] tw-pt-[3px]">{{itemData().campaignName
          ? itemData().campaignName : 'Campaign Title'}}</span>
        <div class="tw-flex  tw-flex-col tw-justify-between tw-h-[117px]">
          <h2 class="tw-text-[22px] tw-font-bold tw-leading-[28px] tw-text-[#041519]">{{itemData().name ?
            itemData().name:'Item Name'}}</h2>
          <div class="tw-flex tw-gap-2 tw-justify-between tw-items-start tw-bg-white">
            <div class="tw-flex tw-flex-col tw-gap-[3px]"
             *ngIf="itemData()?.campaignTypeId!==campaignTypeEnums['Volunteer Activity']">
              <span
                class="tw-text-[14px] tw-font-bold tw-leading-[20px] tw-text-[#041519] tw-pb-[5px]">{{itemData().typeId
                ?
                itemTypeEnum[itemData()?.typeId] :'Item Type'}}</span>
              @if(itemData()?.price){
              <span class="tw-text-[20px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519]">
                {{itemData()?.price | currency:'USD':'symbol':'1.0-0'}}</span>
              }
              @if(customItemPrice()){
              <span class="tw-text-[20px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519]">
                {{customItemPrice() | currency:'USD':'symbol':'1.0-0'}}</span>
              }
            
              <span class="tw-text-[20px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519]">
                {{!isCalledFromItemDrawer ?'':'Item Details'}}</span>
            </div>
           
            <div class="tw-flex tw-flex-col tw-gap-[3px]"
             *ngIf="itemData()?.campaignTypeId===campaignTypeEnums['Volunteer Activity']">
             @if(selectedShift()?.eventStartDateTime || selectedShift()?.eventEndDateTime){
               <ng-container *ngTemplateOutlet="shiftDatesAndTime"></ng-container>         
             }
             @else if(itemData()?.itemEventStartTime || itemData()?.itemEventEndTime){
             <span class="tw-text-[14px] tw-font-bold tw-leading-[20px] tw-text-[#041519] tw-pb-[5px]">{{itemData().typeId
                ? itemTypeEnum[itemData()?.typeId] :'Item Type'}}</span>
               <span class="tw-text-[20px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519]">
                 <ng-container *ngTemplateOutlet="datesAndTime"></ng-container>
               </span>
             }
             @else{
              <span class="tw-text-[14px] tw-font-bold tw-leading-[20px] tw-text-[#041519] tw-pb-[5px]">{{itemData().typeId
                ? itemTypeEnum[itemData()?.typeId] :'Item Type'}}</span>
             }
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div class="tw-flex">
      <button
        class="tw-h-[24px] tw-w-[113px] tw-text-[#5E8E48] tw-font-[Satoshi] tw-text-[11px] tw-font-bold tw-leading-none tw-flex tw-justify-end tw-items-center tw-gap-[6px] tw-px-[10px] tw-py-[4px] tw-rounded-[12px] tw-border tw-border-[#5E8E48] tw-bg-[rgba(94,142,72,0.10)] tw-backdrop-blur-[5px]">
        Participate Now!
      </button>
    </div>
  </div>

  <div
    class="tablet:tw-hidden tw-px-[16px] tw-py-[20px] tw-m-[12px] tw-flex tw-items-start tw-justify-between tw-bg-white tw-border tw-border-[#E3E3E3] tw-rounded-[12px] tw-shadow-sm">
    <div class="tw-flex tw-gap-4 tw-items-start tw-flex-1">
      <div class="tw-flex tw-flex-col tw-gap-1 tw-flex-1">
        <div class="tw-flex tw-pb-[10px] tw-flex tw-w-full  tw-items-center">
          <button type="button"
            class="tw-h-[24px] tw-w-[100px] tw-text-[#5E8E48] tw-font-[Satoshi] tw-text-[10px] tw-font-bold tw-leading-none tw-flex tw-justify-end tw-items-center tw-gap-[6px] tw-px-[10px] tw-py-[4px] tw-rounded-[12px] tw-border tw-border-[#5E8E48] tw-bg-[rgba(94,142,72,0.10)] tw-backdrop-blur-[5px]">
            Participate Now!
          </button>
          <span
            class="tw-pl-[12px] tw-text-[12px] tw-font-medium tw-leading-[18px] tw-text-[#106B8E] tablet:tw-pb-2 tw-max-w-[270px]">{{itemData().campaignName
            ? itemData().campaignName : 'Campaign Title'}}</span>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-1">
          <div class="tw-w-[100px] tw-h-[100px]">
            <img class="tw-w-full tw-h-full tw-bg-white tw-object-cover tw-rounded-[13px]" [src]="isEmpty(itemData()) 
            ? './assets/images/landing/static_image.png' 
            : (itemData().featureImage 
                ? itemData().featureImage 
                : './assets/images/placeholder.png')" [alt]="itemData()?.name">
          </div>
          <div class="tw-flex tw-flex-col tw-pl-3 tw-justify-between tw-flex-1">
            <h2 class="tw-text-[20px] tw-pb-[12px] tw-font-bold tw-leading-[28px] tw-text-[#041519] tw-max-w-[240px]">
              {{itemData().name ? itemData().name:'Item Name'}}</h2>
            <div class="tw-flex tw-gap-2 tw-items-start tw-bg-white tw-w-full">
              <div class="tw-flex tw-flex-col tw-gap-[3px]"
              *ngIf="itemData()?.campaignTypeId!==campaignTypeEnums['Volunteer Activity']">
                <span
                  class="tw-pb-[5px] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-text-[#041519]">{{itemData().typeId
                  ? itemTypeEnum[itemData()?.typeId] :'Item Type'}}</span>
                @if(itemData()?.price){
                <span class="tw-text-[16px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519]">
                  {{itemData()?.price | currency:'USD':'symbol':'1.0-0'}}</span>
                }
                @if(customItemPrice()){
                <span class="tw-text-[20px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519]">
                  {{customItemPrice() | currency:'USD':'symbol':'1.0-0'}}</span>
                }
                <span class="tw-text-[20px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519]">
                  {{!isCalledFromItemDrawer ?'':'Item Details'}}</span>
              </div>
              <div class="tw-flex tw-flex-col tw-gap-[3px] tw-w-full"
              *ngIf="itemData()?.campaignTypeId===campaignTypeEnums['Volunteer Activity']">
                @if(selectedShift()?.eventStartDateTime || selectedShift()?.eventEndDateTime){
                  <ng-container *ngTemplateOutlet="shiftDatesAndTime"></ng-container>   
                }
                @else if(itemData()?.itemEventStartTime || itemData()?.itemEventEndTime){
                <span class="tw-pb-[5px] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-text-[#041519]">{{itemData().typeId
                    ? itemTypeEnum[itemData()?.typeId] :'Item Type'}}</span>
                  <span
                  class="tw-text-[16px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519] tw-max-w-[228px]">
                  <ng-container *ngTemplateOutlet="datesAndTime"></ng-container>
                    </span>
                }
                @else{
                  <span class="tw-pb-[5px] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-text-[#041519]">{{itemData().typeId
                    ? itemTypeEnum[itemData()?.typeId] :'Item Type'}}</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <div *ngIf="isProposeForm"
    class="tablet:tw-flex tw-m-[12px] tablet:tw-ml-[32px] tablet:tw-mt-[12px] tablet:tw-mb-[0px] tablet:tw-mr-[32px] tw-items-start tw-justify-between tw-bg-white tw-border tw-border-[#E3E3E3] tw-rounded-[12px] tw-px-4 tw-py-5 tablet:tw-p-4 tw-gap-4 tw-shadow-sm tw-h-[174px] tablet:tw-h-[182px]">
    <button
      class="tw-mb-[10px] tablet:tw-hidden tw-flex tw-h-[24px] tw-w-[95px] tw-text-[#5E8E48] tw-font-[Satoshi] tw-text-[11px] tw-font-bold tw-leading-none tw-flex  tw-items-center tw-gap-[6px] tw-px-[10px] tw-py-[4px] tw-rounded-[12px] tw-border tw-border-[#5E8E48] tw-bg-[rgba(94,142,72,0.10)] tw-backdrop-blur-[5px]">
      Propose Now!
    </button>
    <div class="tw-flex tw-gap-4 tw-items-start">
      <div class="tablet:tw-w-[150px] tablet:tw-h-[150px] tw-h-[100px] tw-w-[100px]">
        <img class="tw-w-full tw-h-full tw-bg-white tw-object-cover tw-rounded-[13px]"
          [src]="profileUrl ? profileUrl : './assets/images/placeholder.png'" alt="profileImage">
      </div>
      <div class="tw-flex tw-flex-col tw-gap-1">
        <button
          class="tablet:tw-flex tw-hidden tw-h-[24px] tw-w-[95px] tw-text-[#5E8E48] tw-font-[Satoshi] tw-text-[11px] tw-font-bold tw-leading-none tw-flex  tw-items-center tw-gap-[6px] tw-px-[10px] tw-py-[4px] tw-rounded-[12px] tw-border tw-border-[#5E8E48] tw-bg-[rgba(94,142,72,0.10)] tw-backdrop-blur-[5px]">
          Propose Now!
        </button>
        <div class="tw-flex tw-flex-col tw-w-[210px] tablet:tw-w-full">
          <h2 class="tw-mb-[8px] tablet:tw-text-[22px] tw-text-[16px] tw-font-bold tw-leading-[28px] tw-text-[#041519]">
            {{communityData?.displayName}}
          </h2>
          <div class="tw-flex tw-gap-1 tw-items-center">
            <i-icon [name]="'map-marker-bold'" class="!tw-h-4 !tw-w-4 tw-text-[#041519] tw-font-bold"></i-icon>
            <div class="tw-text-[12px] tw-font-bold tw-leading-[20px] tw-text-[#041519]">
              {{communityAddress}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-survey-js [previewFormData]="previewFormData" [isFromParticipateNow]="isFromParticipateNow"
    [selectedPaymentMethod]="selectedPaymentMethod || ''" (surveyDataSubmitted)="onSurveyDataReceived($event)"
    (isValidFilesSize)="onIsValidFilesSize($event)" (isFormValid)="onIsFormValid($event)"
    (invalidExtensionMessage)="onSurveyFileExtnValidation($event)"
    (invalidExtensionMessageCombined)="onSurveyFileExtnValidationCombined($event)"
    (resetPaymentMethod)="resetPaymentMethod()">
  </app-survey-js>


  @if(isOverView){
  <!-- @if(isEmpty(itemData()) || itemData()?.isAcceptPaymentOnline === false){
      <ng-container *ngTemplateOutlet="emptyPayment"></ng-container>
    }
    @else  -->
  @if(!isEmpty(itemData())) {
  @if (!(itemData()?.campaignTypeId === campaignTypeEnum['Volunteer Activity'])) {
  <ng-container *ngTemplateOutlet="paymentMethod"></ng-container>
  }
  <ng-container *ngTemplateOutlet="submitTemplate"></ng-container>
  }
  @else if(!isVolunteer) {
  <ng-container *ngTemplateOutlet="emptyPayment"></ng-container>
  }
  }
  @else if (isProposeForm) {
  <ng-container *ngTemplateOutlet="submitTemplate"></ng-container>
  }




</div>



<ng-template #emptyPayment>
  <div class="tw-ml-8 tw-mr-8 tw-mb-8">
    <h4 class="tw-text-[#041519] tw-text-[18px] tw-font-bold tw-leading-[24px] tw-capitalize tw-pb-[20px]">Payment
      Method</h4>
    <div
      class="tw-border tw-border-[#E3E3E3] tw-rounded-lg tw-bg-[#F8F8F8] tw-flex tw-flex-col tw-justify-center tw-items-center max-md:tw-pt-3 max-md:tw-pb-3">
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
        <img src="./assets/images/payment-static-image.png" alt="preview not available">
      </div>
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-5" *ngIf="!isMobileView">
        <div class="tw-font-medium tw-text-xl tw-text-[#828485]">
          If this form is set to accept payments,
          <br>
          the payment methods will display here.
        </div>
        <div class="tw-flex tw-items-center tw-gap-4 tw-pb-3">
          <i-icon [name]="'Bank'" class="!tw-w-5 !tw-h-5"></i-icon>
          <i-icon [name]="'Card-Payment'" class="!tw-w-5 !tw-h-5 tw-text-primary-700"></i-icon>
        </div>
      </div>
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-5" *ngIf="isMobileView">
        <div class="tw-font-medium tw-text-xl tw-text-[#828485] tw-text-center">
          If this form is set to accept payments, the payment methods will display here.
        </div>
        <div class="tw-flex tw-items-center tw-gap-4 tw-pb-3">
          <i-icon [name]="'Bank'" class="!tw-w-5 !tw-h-5"></i-icon>
          <i-icon [name]="'Card-Payment'" class="!tw-w-5 !tw-h-5 tw-text-primary-700"></i-icon>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #paymentMethod>
  <!-- <div class="tw-mb-[20px] tw-mx-[32px]">
    <label for="amount"
      class="tw-text-[#041519] tw-text-[18px] tw-font-bold tw-leading-[24px] tw-capitalize">Amount</label>
    <input id="amount" [(ngModel)]="amount" type="number" min="1" placeholder="Enter amount" required
      class="tw-w-full tw-border tw-px-2 tw-py-1 tw-rounded-md tw-mt-[10px]" />
  </div>  -->

  <!-- Payment Method -->

  <div class="tw-relative">
    <div *ngIf="itemData().isAcceptPaymentOnline" class="tw-pl-[32px] tw-pr-[32px] tw-pb-[32px] tw-relative tw-z-10">
      <h4
        class="tw-text-[#041519] tw-text-[18px] tw-font-bold tw-leading-[24px] tw-capitalize tw-pb-[20px] tw-pt-[15px]">
        Payment
        Method</h4>
      <div class="tw-border tw-border-[#E3E3E3] tw-rounded-md tw-overflow-hidden tw-bg-white tw-w-full">
        <div class="tw-flex tw-flex-col">
          <label
            class="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 tw-border-b tw-border-[#E3E3E3] tw-cursor-pointer">
            <input type="radio" name="payment" value="card" [(ngModel)]="selectedPaymentMethod"
              (ngModelChange)="onPaymentMethodChange($event)"
              class="tw-form-radio tw-text-teal-600 tw-accent-teal-600" />
            <div class="tw-flex tw-items-center tw-gap-2">
              <img src="./assets/images/survey-card.svg" class="tablet:tw-w-[20px] tablet:tw-h-[16px]" />
              <span class="tw-text-sm tw-text-[#041519] tw-font-medium">Card</span>
            </div>
          </label>
          <!-- @if(selectedPaymentMethod === 'card'){
        <ng-container *ngTemplateOutlet="paymentForm"></ng-container>
        } -->

          <!-- Card Payment Fields -->
          <div *ngIf="selectedPaymentMethod === 'card'" class="tw-p-[12px]">
            <!-- <label for="card-element" class="card-info tw-mb-2">Card Information</label> -->
            <div id="card-element">
              <!-- Stripe Card Element will be inserted here -->
            </div>
          </div>
        </div>

        <!-- Option 2 -->
        <div class="tw-flex tw-flex-col">
          <label
            class="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 tw-border-b tw-border-[#E3E3E3] tw-cursor-pointer">
            <input type="radio" name="payment" value="bank" [(ngModel)]="selectedPaymentMethod"
              (ngModelChange)="onPaymentMethodChange($event)"
              class="tw-form-radio tw-text-teal-600 tw-accent-teal-600" />
            <div class="tw-flex tw-items-center tw-gap-2">
              <img src="./assets/images/survey-bank.svg" class="tablet:tw-w-[20px] tablet:tw-h-[20px]" />
              <span class="tw-text-sm tw-text-[#041519] tw-font-medium">US bank account</span>
            </div>
          </label>
          <!-- @if(selectedPaymentMethod === 'bank'){
        <ng-container *ngTemplateOutlet="paymentForm"></ng-container>
        } -->
          <!-- Bank Account Payment Fields (if applicable) -->
          <div *ngIf="selectedPaymentMethod === 'bank'" class="tw-p-[12px]">
            <!-- <label for="bank-account tw-mb-2">Bank Account Details</label> -->
            <div id="bank-account-element">
              <!-- <div id="payment-request-button"> -->
              <!-- ACH Bank Account Element goes here, or custom form to collect bank details -->
            </div>
          </div>
        </div>
        <!-- Option 3 -->
        <div *ngIf="isGooglePayAvailable" class="tw-flex tw-flex-col">
          <label class="tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 tw-cursor-pointer">
            <input type="radio" name="payment" value="gpay" [(ngModel)]="selectedPaymentMethod"
              (ngModelChange)="onPaymentMethodChange($event)"
              class="tw-form-radio tw-text-teal-600 tw-accent-teal-600" />
            <div class="tw-flex tw-items-center tw-gap-2">
              <img src="./assets/images/survey-gpay.svg" class="tablet:tw-w-[28px] tablet:tw-h-[15px]" />
              <span class="tw-text-sm tw-text-[#041519] tw-font-medium">Google Pay</span>
            </div>
          </label>
          <!-- <div>
           <span class="tw-text-sm tw-text-[#041519] tw-font-medium">Pay with ACH</span>
           <div id="iban-element"> -->
          <!-- Stripe ACH Element will be mounted here -->
          <!-- </div> -->
          <!-- <button (click)="onSubmit()">Submit Payment</button> -->
          <!-- </div> -->
          @if(selectedPaymentMethod === 'gpay'){
          <div class="tw-p-[12px]">
            <div id="google-pay-button"></div>
          </div>
          }
        </div>

      </div>
    </div>
  </div>
</ng-template>

<ng-template #submitTemplate>
  <div class="tw-flex tw-justify-end tw-pl-[32px] tw-pr-[32px] tw-pb-[50px]"
    *ngIf="(isFromParticipateNow && selectedPaymentMethod !== 'gpay') || isProposeForm">
    <button type="submit" class="tw-w-full submit-button tw-h-[40px] tablet:tw-h-[62px] tw-w-full tablet:tw-w-[200px]"
      (click)="handleSubmit($event)">
      Submit
    </button>
  </div>
</ng-template>


<ng-template #paymentForm>
  <div *ngIf="!!selectedPaymentMethod" class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-p-[12px]">
    <div>
      <label for="email" class="fields">Email</label>
      <input id="email" [(ngModel)]="email" type="email" placeholder="Enter your email" required
        class="tw-w-full tw-border tw-px-2 tw-py-1 tw-rounded-md" />
    </div>

    <div>
      <label for="phone" class="fields">Phone</label>
      <input id="phone" [(ngModel)]="phone" type="tel" placeholder="Enter your phone number" required
        class="tw-w-full tw-border tw-px-2 tw-py-1 tw-rounded-md" />
    </div>

    <div>
      <label for="address" class="fields">Address Line 1</label>
      <input id="address" [(ngModel)]="address" type="text" placeholder="Enter your address" required
        class="tw-w-full tw-border tw-px-2 tw-py-1 tw-rounded-md" />
    </div>

    <div>
      <label for="address2" class="fields">Address Line 2</label>
      <input id="address2" [(ngModel)]="address2" type="text" placeholder="Apartment, suite, etc."
        class="tw-w-full tw-border tw-px-2 tw-py-1 tw-rounded-md" />
    </div>

    <div>
      <label for="city" class="fields">City</label>
      <input id="city" [(ngModel)]="city" type="text" placeholder="Enter your city" required
        class="tw-w-full tw-border tw-px-2 tw-py-1 tw-rounded-md" />
    </div>

    <div>
      <label for="postalCode" class="fields">Postal Code</label>
      <input id="postalCode" [(ngModel)]="postalCode" type="text" placeholder="Enter your postal code" required
        class="tw-w-full tw-border tw-px-2 tw-py-1 tw-rounded-md" />
    </div>

    <!-- <div class="md:tw-col-span-2">
      <label for="country" class="fields">Country</label>
      <input id="country" [(ngModel)]="country" type="text" placeholder="Enter your country" required class="tw-w-full tw-border tw-px-2 tw-py-1 tw-rounded-md" />
    </div> -->
    <div class="md:tw-col-span-2">
      <label for="country" class="fields">Country</label>
      <select id="country" [(ngModel)]="country" required class="tw-w-full tw-border tw-px-2 tw-py-1 tw-rounded-md">
        <option value="" disabled selected>Select your country</option>
        <option *ngFor="let c of countryList" [value]="c.code">{{ c.name }}</option>
      </select>
    </div>
  </div>
</ng-template>

<ng-template #shiftDatesAndTime>
  <div class="tw-flex tw-items-baseline tablet:tw-gap-5 max-md:tw-justify-between">


  <div class="tw-flex tw-flex-col tw-gap-1">
    <div class="tw-font-bold tablet:tw-text-sm tw-text-xs">
      Shift Title
    </div>
    <div
      [smlTooltip]="selectedShift()?.title"
      class="tablet:tw-text-[16px] tw-text-[10px] tw-font-medium tw-leading-[20px] tw-not-italic tw-text-[#041519] min-[769px]:tw-w-[200px] max-[768px]:tw-max-w-[70px] tw-break-words tw-overflow-hidden tw-text-ellipsis" style="
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    " >
     {{selectedShift()?.title}}
    </div>
  </div>
  <div class="tw-flex tw-flex-col tw-gap-1">
   <div class="tw-font-bold tablet:tw-text-sm tw-text-xs">
    Date & Time
  </div>
  <div
  class="tablet:tw-text-[16px] tw-text-[10px] tw-font-medium tw-leading-[20px] tw-not-italic tw-text-[#041519]">
  <div>
    {{timeZoneData?.startDateInSelectedTimezone | date:'EEEE, MMMM d, y'}}
  </div>
    <span>
      {{timeZoneData?.startDateInSelectedTimezone | date: 'h:mm a'}}
    </span>
    <span>
      - {{timeZoneData?.endDateInSelectedTimezone | date: 'h:mm a'}}
    </span>
    <span>
      ({{ timeZoneData?.itemTimeZone }})
    </span>
  </div>
</div>
</div>
</ng-template>

<ng-template #datesAndTime>
  <div class="tw-flex tw-flex-row tw-items-center tw-gap-1">
    <div class="tw-flex tw-flex-row tw-items-center tw-gap-[2px]">
      <div *ngIf="itemData()?.itemDateEventType==dateEnum['Multi Day Event']">
        <div
          class="tw-text-[11px] tablet:tw-text-[20px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519]">
          {{timeZoneData?.startDateInSelectedTimezone | date: 'MM/dd/yyyy'}} - {{timeZoneData?.endDateInSelectedTimezone
          | date: 'MM/dd/yyyy'}}
        </div>
      </div>
      <div *ngIf="itemData()?.itemDateEventType==dateEnum['Single Day Event']">
        <div
          class="tw-text-[11px] tablet:tw-text-[20px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519]">
          {{timeZoneData?.startDateInSelectedTimezone | date: 'MM/dd/yyyy'}}
        </div>
      </div>
      <div *ngIf="itemData()?.itemDateEventType==dateEnum['Single Day Event']">
        <div
          class="tw-ml-1 tw-text-[11px] tablet:tw-text-[20px] tw-font-bold tw-leading-[20px] tw-not-italic tw-text-[#041519]">
          <span *ngIf="timeZoneData?.startTimePatch && itemData()?.hasEventTimeEntered">
            {{timeZoneData?.startDateInSelectedTimezone | date: 'h:mm a'}}
          </span>
          <span *ngIf="timeZoneData?.endTimePatch && itemData()?.hasEventTimeEntered">
            - {{timeZoneData?.endDateInSelectedTimezone | date: 'h:mm a'}}
          </span>
          <span *ngIf="timeZoneData?.startTimePatch || timeZoneData?.endTimePatch">
            ({{ timeZoneData?.itemTimeZone }})
          </span>
        </div>
      </div>
    </div>

  </div>
</ng-template>

<!-- @if(showCancelSurveyDialog){
  <sml-dialog #smlCancelSurveyModal [size]="'md'" [hasConfirmationDialog]="true" [isOpen]="showCancelSurveyDialog" [bodyClass]="'!tw-mb-[5rem]'"
    [dialogTitle]="formDetailStrings.CLOSE_FORM" [dialogTitlePosition]="'center'"
    [dialogHeaderContent]="formDetailStrings.CLOSE_FORM_SUBHEADING" [dialogHeaderContentPosition]="'center'"
    (closed)="onClosePopup()" [src]="'./assets/images/landing/exclamation.png'" [iconPosition]="'center'">
    <ng-container footer *ngIf="showCancelSurveyDialog">
      <div
        class="tw-flex tw-justify-between tw-items-center tw-py-4 tw-px-8 tw-border-t tw-border-solid tw-border-mercury-200">
        <button smlButton="link" [size]="'sm'" [rounded]="'md'" (click)="onCloseFormDialog()" class="!tw-pl-0">
          {{ formDetailStrings.CLOSE_FORM_CANCEL_TEXT }}
        </button>
        <div class="">
          <button smlButton="primary" [size]="'sm'" [rounded]="'md'" (click)="onConfirmCloseFormDialog()">
            {{formDetailStrings.CLOSE_FORM_SAVE_TEXT }}
          </button>
        </div>
      </div>
    </ng-container>
  </sml-dialog>
  } -->